import { observer } from 'mobx-react-lite'
import { TextInputContainer } from '@/components/inputs/TextInputContainer'
import { FormRow } from '@/components/Form'
import { useFeatures } from '@/contexts/root-store-context'
import { NewTeamModal } from '@/features/iam/teams/NewTeamModal'
import { type NewTeamModalViewModel } from './NewTeamModalViewModel'

export interface NewTeamModalContainerProps {
  vm: NewTeamModalViewModel
}

export const NewTeamModalContainer = observer(function NewTeamModalContainer({
  vm,
}: NewTeamModalContainerProps) {
  const { shellInfo } = useFeatures(({ shell }) => ({
    shellInfo: shell.shellInfo,
  }))
  return (
    <NewTeamModal
      showing={vm.modal.showing}
      onClose={vm.modal.close}
      corporateMode={shellInfo.corporateMode}
      onSubmit={vm.submit}
      isCreatePending={vm.createTeam.pending}
      createError={vm.createTeam.rejected ? vm.createTeam.error : null}
      onDismissError={vm.createTeam.reset}
    >
      <FormRow>
        <TextInputContainer
          label="Team Name"
          field="name"
          model={vm}
          error={vm.validation.getError('name')}
          onBlur={vm.suggestSlug}
        />
      </FormRow>
      <FormRow>
        <TextInputContainer
          label="URL Slug"
          help="This field will indicate your unique identifier within this workspace. Must be alphanumerical including dashes (except at the beginning and end)"
          field="slug"
          error={vm.validation.getError('slug')}
          model={vm}
        />
      </FormRow>
    </NewTeamModal>
  )
})
